module.exports = __webpack_public_path__ + "img/storm.c9d41d2a.svg";